import {hideError, showError} from "../actions/actions";
import axios from "axios";
import {API_URL} from "../config";
import {
    GET_NOTIFICATION_ERROR,
} from "../types/types";
import {showAccessDeniedNotifications} from "../actions/actionsNotifications";
import {SET_USER_STATUS_ERROR, SET_USER_STATUS_SUCCESS} from "../types/typesUsersList";
import {GET_TRUNK, GET_TRUNK_PAGINATION, GET_TRUNKS, GET_DEFAULT_TRUNK_SETTINGS_LIST, SHOW_TRUNK_DETAIL_LOADING} from "../types/typesTrunkList";
import {setTrunkErrorField, showTrunkLoader} from "../actions/actionsTrunk";
import {getBranchDetailById} from "./apiBranchList";
export const API_TRUNK_OUT_PREFIX_DEFAULT = {
    did_Count: 0,
    did_Prefix: "",
    cid_Count: 0,
    cid_Prefix: "",
    cid_Number: "",
    isPai: false,
    pai_Number: "",
    pai_Count: 0,
    pai_Prefix: "",
} as const;

export const API_TRUNK_IN_PREFIX_DEFAULT = {
    isPai: false,
    isDiversions: false,
} as const;

function pickTrunkBool(v: unknown): boolean {
    if (v === true || v === "true" || v === 1) return true;
    return false;
}

function pickTrunkString(v: unknown): string {
    if (v == null) return "";
    return String(v);
}

function pickTrunkCount(v: unknown): number {
    if (v === null || v === undefined || v === "") return 0;
    const n = Number(v);
    return Number.isNaN(n) ? 0 : n;
}

export function normalizeTrunkOutPrefix(raw: unknown): Record<string, string | number | boolean> {
    if (raw == null || typeof raw !== "object" || Array.isArray(raw)) {
        return {...API_TRUNK_OUT_PREFIX_DEFAULT};
    }
    const o = raw as Record<string, unknown>;
    return {
        did_Count: pickTrunkCount(o.did_Count ?? o.didCount ?? o.Did_Count ?? o.DidCount),
        did_Prefix: pickTrunkString(o.did_Prefix ?? o.didPrefix ?? o.Did_Prefix ?? o.DidPrefix),
        cid_Count: pickTrunkCount(o.cid_Count ?? o.cidCount ?? o.Cid_Count ?? o.CidCount),
        cid_Prefix: pickTrunkString(o.cid_Prefix ?? o.cidPrefix ?? o.Cid_Prefix ?? o.CidPrefix),
        cid_Number: pickTrunkString(o.cid_Number ?? o.cidNumber ?? o.Cid_Number ?? o.CidNumber),
        isPai: pickTrunkBool(o.isPai ?? o.IsPai ?? o.isPai_Out ?? o.IsPai_Out),
        pai_Number: pickTrunkString(o.pai_Number ?? o.paiNumber ?? o.Pai_Number ?? o.PaiNumber),
        pai_Count: pickTrunkCount(o.pai_Count ?? o.paiCount ?? o.Pai_Count ?? o.PaiCount),
        pai_Prefix: pickTrunkString(o.pai_Prefix ?? o.paiPrefix ?? o.Pai_Prefix ?? o.PaiPrefix),
    };
}

export function normalizeTrunkInPrefix(raw: unknown): Record<string, boolean> {
    if (raw == null || typeof raw !== "object" || Array.isArray(raw)) {
        return {...API_TRUNK_IN_PREFIX_DEFAULT};
    }
    const o = raw as Record<string, unknown>;
    return {
        isPai: pickTrunkBool(o.isPai ?? o.IsPai ?? o.isPai_In ?? o.IsPai_In),
        isDiversions: pickTrunkBool(o.isDiversions ?? o.Is_Diversions ?? o.IsDiversions),
    };
}

export function findDefaultTrunkSettingsRowById(
    rows: unknown,
    optionId: unknown
): Record<string, unknown> | null {
    if (!Array.isArray(rows) || optionId === null || optionId === undefined || optionId === "") {
        return null;
    }
    for (const item of rows) {
        if (item == null || typeof item !== "object") continue;
        const o = item as Record<string, unknown>;
        const rowId =
            o.defaultTrunkId ??
            o.DefaultTrunkId ??
            o.id ??
            o.trunkId ??
            o.TrunkId ??
            o.sofiaTrunkId;
        if (rowId === optionId || String(rowId) === String(optionId)) {
            return o;
        }
    }
    return null;
}

/** Рядок з GetDefaultTrunkSettingsList (isPai_In / isPai_Out) → поля для trunkData. */
export function trunkPrefixesFromDefaultSettingsRow(row: unknown): {
    outPrefix: ReturnType<typeof normalizeTrunkOutPrefix>;
    inPrefix: ReturnType<typeof normalizeTrunkInPrefix>;
    needPaiNumber: boolean;
    providerLibraryId: number | string | null;
} | null {
    if (row == null || typeof row !== "object") return null;
    const o = row as Record<string, unknown>;
    const outPrefix = normalizeTrunkOutPrefix(o);
    const inPrefix = normalizeTrunkInPrefix(o);
    const providerRaw =
        o.id ??
        o.sofiaTrunkId ??
        o.defaultTrunkId ??
        o.DefaultTrunkId ??
        null;
    const providerLibraryId =
        providerRaw === "" || providerRaw === undefined ? null : (providerRaw as number | string);
    return {
        outPrefix,
        inPrefix,
        needPaiNumber: pickTrunkBool(o.needPaiNumber ?? o.NeedPaiNumber),
        providerLibraryId,
    };
}

function mergeTrunkSipConfiguration(r: Record<string, unknown>): void {
    const rawOut = r.outPrefix ?? r.OutPrefix;
    const rawIn = r.inPrefix ?? r.InPrefix;
    r.outPrefix = normalizeTrunkOutPrefix(rawOut);
    r.inPrefix = normalizeTrunkInPrefix(rawIn);
    delete r.OutPrefix;
    delete r.InPrefix;
    const pl = r.providerLibraryId ?? r.ProviderLibraryId;
    r.providerLibraryId =
        pl === "" || pl === undefined || pl === null ? null : pl;
    delete r.ProviderLibraryId;
}

function normalizeTrunkDetailPayload(raw: unknown): unknown {
    if (raw == null || typeof raw !== "object" || Array.isArray(raw)) {
        return raw;
    }
    const r = {...(raw as Record<string, unknown>)};
    let gts = r.generalTrunkSettings;
    if (typeof gts === "string" && gts.trim() !== "") {
        try {
            gts = JSON.parse(gts) as unknown;
        } catch {
            gts = null;
        }
    }
    if (gts != null && typeof gts === "object" && !Array.isArray(gts)) {
        const go = gts as Record<string, unknown>;
        if (r.branchId == null && (go.branchId != null || go.BranchId != null)) {
            r.branchId = go.branchId ?? go.BranchId;
        }
        if (
            r.defaultTrunkId == null &&
            (go.defaultTrunkId != null || go.DefaultTrunkId != null)
        ) {
            r.defaultTrunkId = go.defaultTrunkId ?? go.DefaultTrunkId;
        }
    }
    delete r.generalTrunkSettings;
    if (r.branchId == null && r.BranchId != null) {
        r.branchId = r.BranchId;
    }
    delete r.BranchId;
    if (r.defaultTrunkId == null && r.DefaultTrunkId != null) {
        r.defaultTrunkId = r.DefaultTrunkId;
    }
    delete r.DefaultTrunkId;
    mergeTrunkSipConfiguration(r);
    if (r.needPaiNumber !== undefined || r.NeedPaiNumber !== undefined) {
        r.needPaiNumber = pickTrunkBool(r.needPaiNumber ?? r.NeedPaiNumber);
    }
    delete r.NeedPaiNumber;
    return r;
}

function trunkPayloadForSave(data: Record<string, unknown>): Record<string, unknown> {
    const {generalTrunkSettings: _g, DefaultTrunkId: _dt, BranchId: _bi, ...rest} = data;
    return {...rest};
}

function trunkPhoneId(phone: unknown): unknown {
    if (phone == null || typeof phone !== "object") return null;
    const p = phone as Record<string, unknown>;
    return p.id ?? p.Id ?? null;
}

function trunkPhoneNo(phone: unknown): string {
    if (phone == null || typeof phone !== "object") return "";
    const p = phone as Record<string, unknown>;
    const raw = p.phoneNo ?? p.PhoneNo;
    return raw == null ? "" : String(raw);
}

function trunkPhoneArchived(phone: unknown): boolean {
    if (phone == null || typeof phone !== "object") return false;
    const p = phone as Record<string, unknown>;
    return p.isArchived === true || p.IsArchived === true;
}

export function trunkPhonesNeedIdReload(phones: unknown): boolean {
    if (!Array.isArray(phones) || phones.length === 0) return true;
    return phones.some((p) => trunkPhoneId(p) == null);
}

/** Підставляє id існуючих номерів при оновленні транка (без id бекенд створює дублікати). */
export function mergeTrunkPhonesWithIds(
    phones: unknown[],
    existingPhones: unknown[] | null | undefined
): Record<string, unknown>[] {
    if (!Array.isArray(phones)) return [];
    const existing = Array.isArray(existingPhones) ? existingPhones : [];
    const usedIds = new Set<unknown>();
    phones.forEach((phone) => {
        const id = trunkPhoneId(phone);
        if (id != null) usedIds.add(id);
    });
    return phones.map((phone) => {
        if (phone == null || typeof phone !== "object") {
            return phone as Record<string, unknown>;
        }
        const p = {...(phone as Record<string, unknown>)};
        if (trunkPhoneId(p) != null) {
            return p;
        }
        const phoneNo = trunkPhoneNo(p);
        if (!phoneNo) return p;
        const match = existing.find((ep) => {
            const id = trunkPhoneId(ep);
            if (id == null || usedIds.has(id) || trunkPhoneArchived(ep)) return false;
            return trunkPhoneNo(ep) === phoneNo;
        }) as Record<string, unknown> | undefined;
        if (match) {
            const id = trunkPhoneId(match);
            usedIds.add(id);
            return {...p, id};
        }
        return p;
    });
}

function flattenTrunkApiErrorMessages(val: unknown): string {
    if (Array.isArray(val)) {
        return val
            .map((x) => (typeof x === "string" ? x : String(x)))
            .filter(Boolean)
            .join(" ");
    }
    if (val != null && typeof val === "object" && "message" in val) {
        return String((val as { message: unknown }).message);
    }
    if (val == null) return "";
    return String(val);
}

/** Розбір `errors` з відповіді збереження транка (напр. Phones[0].PhoneNo). */
export function mapTrunkSaveResponseErrors(responseData: any): Record<string, unknown> {
    const raw =
        responseData?.errors ??
        responseData?.Errors ??
        responseData?.data?.errors ??
        responseData?.data?.Errors;
    if (raw == null || typeof raw !== "object" || Array.isArray(raw)) {
        return {};
    }
    const out: Record<string, unknown> = {};
    const phoneRowErrors: Record<number, string> = {};
    for (const [key, val] of Object.entries(raw)) {
        if (
            /^GeneralTrunkSettings\.BranchId$/i.test(key) ||
            /^generalTrunkSettings\.branchId$/i.test(key) ||
            /^BranchId$/i.test(key) ||
            key === "branchId"
        ) {
            const text = flattenTrunkApiErrorMessages(val);
            if (text) {
                out.branchId = {branchId: text};
            }
            continue;
        }
        if (
            /^GeneralTrunkSettings\.DefaultTrunkId$/i.test(key) ||
            /^generalTrunkSettings\.defaultTrunkId$/i.test(key) ||
            /^DefaultTrunkId$/i.test(key) ||
            key === "defaultTrunkId"
        ) {
            const text = flattenTrunkApiErrorMessages(val);
            if (text) {
                out.defaultTrunkId = {defaultTrunkId: text};
            }
            continue;
        }
        const phoneMatch = /^Phones\[(\d+)\]\.PhoneNo$/i.exec(key);
        if (phoneMatch) {
            const idx = Number(phoneMatch[1]);
            const text = flattenTrunkApiErrorMessages(val);
            phoneRowErrors[idx] = text || "Поле номера обов'язкове.";
            continue;
        }
        if (/^Name$/i.test(key)) {
            const text = flattenTrunkApiErrorMessages(val);
            if (text) {
                out.nameUniq = text;
            }
        }
    }
    if (Object.keys(phoneRowErrors).length > 0) {
        out.phoneRowErrors = phoneRowErrors;
        out.phones = {phones: "Перевірте заповнення номерів *"};
    }
    return out;
}

let dataSort = {
    isActive: true,
    pageNumber: 1,
    pageSize: 10,
    sort: {
        orderBy: "Id",
        isDesc: true
    }
}

export function getAllTrunksWithPagination(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(showTrunkLoader(true))
        dispatch(hideError())
        axios.post(`${API_URL}Trunks/GetTrunksWithPagination`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dataSort = data;
                if (data.isArchived === false) {
                    dispatch({type: GET_TRUNKS, payload: response.data.data.items})
                } else {
                    dispatch({type: GET_TRUNKS, payload: response.data.data.items})
                }
                dispatch({type: GET_TRUNK_PAGINATION, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showTrunkLoader(false));
                dispatch(hideError());
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function getTrunkById(id: number, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch({type: SHOW_TRUNK_DETAIL_LOADING, payload: true});
        dispatch(hideError());
        axios.get(`${API_URL}Trunks/GetTrunkById?trunkId=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({
                    type: GET_TRUNK,
                    payload: normalizeTrunkDetailPayload(response.data.data),
                });
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SHOW_TRUNK_DETAIL_LOADING, payload: false});
            })
    }
}

export function getDefaultTrunkSettingsList(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        axios
            .get(`${API_URL}Trunks/GetDefaultTrunkSettingsList`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            })
            .then((response) => {
                const root = response.data;
                if (root?.statusCode === 200 && root.data != null) {
                    dispatch({
                        type: GET_DEFAULT_TRUNK_SETTINGS_LIST,
                        payload: root.data,
                    });
                    return;
                }
                const items = root?.data ?? root?.Data ?? root;
                if (items != null) {
                    dispatch({
                        type: GET_DEFAULT_TRUNK_SETTINGS_LIST,
                        payload: items,
                    });
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError());
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
            });
    };
}

export function createTrunk(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setTrunkErrorField(null));
        dispatch(hideError());
        axios.post(`${API_URL}Trunks/CreateTrunk`, trunkPayloadForSave(data as Record<string, unknown>), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    const normalized = normalizeTrunkDetailPayload(
                        response.data.data
                    ) as Record<string, unknown>;
                    dispatch({
                        type: GET_TRUNK,
                        payload: normalized,
                    });
                    const trunkId = normalized?.id;
                    if (
                        trunkId != null &&
                        trunkPhonesNeedIdReload(normalized?.phones)
                    ) {
                        dispatch(getTrunkById(Number(trunkId), jwtToken));
                    }
                    dispatch(getAllTrunksWithPagination(dataSort, jwtToken));
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
                if (response.data.statusCode === 400) {
                    const mapped = mapTrunkSaveResponseErrors(response.data);
                    if (Object.keys(mapped).length > 0) {
                        dispatch(setTrunkErrorField(mapped));
                    } else {
                        dispatch(
                            setTrunkErrorField({
                                nameUniq: "Назва транка вже існує",
                            })
                        );
                    }
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function updateTrunk(data: any, jwtToken: any, branchId?: number | null) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setTrunkErrorField(null));
        dispatch(hideError());
        axios.post(`${API_URL}Trunks/UpdateTrunk`, trunkPayloadForSave(data as Record<string, unknown>), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({
                        type: GET_TRUNK,
                        payload: normalizeTrunkDetailPayload(response.data.data),
                    })
                    dispatch(getAllTrunksWithPagination(dataSort, jwtToken));
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    if (branchId) {
                        dispatch(getBranchDetailById(branchId, jwtToken));
                    }
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
                if (response.data.statusCode === 400) {
                    const mapped = mapTrunkSaveResponseErrors(response.data);
                    if (Object.keys(mapped).length > 0) {
                        dispatch(setTrunkErrorField(mapped));
                    } else {
                        dispatch(
                            setTrunkErrorField({
                                nameUniq: "Назва транка вже існує",
                            })
                        );
                    }
                }
                if (response.data.statusCode === 402) {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function archiveTrunkPhoneById(id: number, phoneId: number, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        axios.post(`${API_URL}Trunks/ArchiveTrunkPhoneById?trunkPhoneId=${phoneId}`, null, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`,
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch(getTrunkById(id, jwtToken));
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}

export function inactiveTrunkPhoneById(id: number, trunkId: number, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        axios.post(`${API_URL}Trunks/InActiveTrunkPhoneById?trunkId=${id}`, null, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`,
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch(getTrunkById(trunkId, jwtToken));
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}

export function archiveOrUnArchiveTrunkById(id: number, jwtToken: any, sort?: any) {
    return (dispatch: (arg0: any) => void) => {
        axios.post(`${API_URL}Trunks/ArchiveTrunkById?trunkId=${id}`, {}, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`,
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch(getAllTrunksWithPagination(sort || dataSort, jwtToken));
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}


